export const isWindowInIframe = () => {
  try {
    return window !== window.parent;
  } catch {
    return true;
  }
};
